var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfilei = function SvgProfilei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Trigger Area"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M17.124 13.603a5.817 5.817 0 0 0-2.184-1.481 4.607 4.607 0 1 0-5.887 0 5.807 5.807 0 0 0-2.183 1.48 8.311 8.311 0 0 0-1.852 5.759.8.8 0 0 0 .8.738h12.361a.8.8 0 0 0 .8-.738 8.315 8.315 0 0 0-1.855-5.758zm-8.135-5a3.007 3.007 0 1 1 3.008 3.007 3.011 3.011 0 0 1-3.012-3.002zm-2.368 9.892a6.247 6.247 0 0 1 1.43-3.819 6.042 6.042 0 0 1 7.892 0 6.257 6.257 0 0 1 1.431 3.818z",
    "data-name": "Path 10982"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfilei);
export default ForwardRef;